import PropTypes from 'prop-types';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { useMemo } from 'react';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TimelineZeroStateAdvancedFilters({
  noResults,
  onResetFilters
}) {
  const renderedResetFiltersButton = useMemo(() => {
    /**
     * @todo Filters redesign: Determine if we want a reset filters button and
     * exactly what it should reset. Currently, onResetFilters is always undefined
     * so we never render a button.
     */
    if (!onResetFilters) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      onClick: onResetFilters,
      responsive: false,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "timeline.filters.clearFilters"
      })
    }, "clear-button");
  }, [onResetFilters]);
  const renderedDescription = useMemo(() => {
    /**
     * @todo Filters redesign: Determine if we want a special zero state message when
     * the user has no event types selected. Currently, noResults is always true so we
     * always display the same message.
     */
    if (noResults) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "timeline.zeroState.advancedFilters.description.noSearchResultsTips.header"
        }), /*#__PURE__*/_jsxs(List, {
          styled: true,
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "timeline.zeroState.advancedFilters.description.noSearchResultsTips.firstTip"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "timeline.zeroState.advancedFilters.description.noSearchResultsTips.secondTip"
          })]
        })]
      }, "subtitle");
    }
    return /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "timeline.zeroState.advancedFilters.description.noFiltersSelected"
      })
    }, "subtitle");
  }, [noResults]);
  return /*#__PURE__*/_jsx(EmptyState, {
    reverseOrder: true,
    titleText: noResults ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.zeroState.advancedFilters.title.noSearchResults"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.zeroState.advancedFilters.title.noFiltersSelected"
    }),
    primaryContent: [renderedDescription, renderedResetFiltersButton],
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      width: "100%"
    }),
    secondaryContentWidth: 200
  });
}
TimelineZeroStateAdvancedFilters.propTypes = {
  noResults: PropTypes.bool,
  onResetFilters: PropTypes.func
};
export default TimelineZeroStateAdvancedFilters;